import type { DateValue } from "@bundle/contracts";
import { useState } from "react";
import { Button, DatePicker, Divider, Stack, Toggle } from "../../primitives/index.ts";
import { useLocale, useT } from "../../i18n/I18nProvider.tsx";

export type DateEditorProps = {
  value: DateValue | undefined;
  weekStartsOn: number;
  onChange: (value: DateValue | undefined) => void;
  testID: string;
};

/** Date cell editor: a month calendar, an "End date" switch for ranges and Clear. Keeps a date-time's time. */
export function DateEditor({ value, weekStartsOn, onChange, testID }: DateEditorProps) {
  const t = useT();
  const locale = useLocale();
  const [range, setRange] = useState(value?.end !== undefined);
  const start = value?.start.slice(0, 10);
  const end = value?.end?.slice(0, 10);
  return (
    <Stack gap="1" paddingY="1" testID={testID}>
      <DatePicker
        value={start}
        end={range ? end : undefined}
        range={range}
        weekStartsOn={weekStartsOn}
        locale={locale}
        onChange={(s, e) => onChange(e === undefined ? { start: s } : { start: s, end: e })}
        testID={`${testID}-calendar`}
      />
      <Divider />
      <Stack gap="1" paddingX="3" paddingY="1">
        <Toggle
          value={range}
          onChange={(on) => {
            setRange(on);
            if (!on && value !== undefined) onChange({ start: value.start });
          }}
          label={t("db.date.end")}
          testID={`${testID}-range`}
        />
        <Stack direction="horizontal" justify="end">
          <Button label={t("db.date.clear")} variant="ghost" size="sm" onPress={() => onChange(undefined)} testID={`${testID}-clear`} />
        </Stack>
      </Stack>
    </Stack>
  );
}
